var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstDealImage4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 2.2518C15.196 2.217 15.5956 2.2002 16 2.2002C23.6212 2.2002 29.8 8.379 29.8 16.0002C29.8 16.4046 29.7832 16.8042 29.7484 17.2002H27.9412C27.3388 23.2638 22.222 28.0002 16 28.0002C9.3724 28.0002 4 22.6278 4 16.0002C4 9.7782 8.7364 4.6614 14.8 4.0602V2.2506V2.2518ZM14.8 17.2002V6.4746C12.3793 6.78262 10.1666 8.00084 8.61183 9.88166C7.05703 11.7625 6.27674 14.1648 6.42954 16.6002C6.58235 19.0357 7.6568 21.3216 9.43449 22.9933C11.2122 24.6651 13.5597 25.5972 16 25.6002C18.3383 25.6002 20.5963 24.7468 22.3501 23.2002C24.1039 21.6536 25.2331 19.5202 25.5256 17.2002H14.8ZM27.3376 14.8002C27.0625 12.2057 25.906 9.78395 24.0611 7.93906C22.2162 6.09417 19.7945 4.9377 17.2 4.6626V14.8002H27.3376Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstDealImage4);
export default __webpack_public_path__ + "static/media/firstDealImage4.a9b0e04d7292a54a1e2725cd45a38ffc.svg";
export { ForwardRef as ReactComponent };